var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var SecondNumberImage = function () {
    return (_jsx("svg", __assign({ width: "82", height: "107", viewBox: "0 0 82 107", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M4.25 107V93.95L45.95 54.35C49.45 51.05 52.05 48.15 53.75 45.65C55.45 43.15 56.55 40.85 57.05 38.75C57.65 36.55 57.95 34.5 57.95 32.6C57.95 27.8 56.3 24.1 53 21.5C49.7 18.8 44.85 17.45 38.45 17.45C33.35 17.45 28.7 18.35 24.5 20.15C20.4 21.95 16.85 24.7 13.85 28.4L0.2 17.9C4.3 12.4 9.8 8.14999 16.7 5.15C23.7 2.05 31.5 0.499994 40.1 0.499994C47.7 0.499994 54.3 1.74999 59.9 4.24999C65.6 6.65 69.95 10.1 72.95 14.6C76.05 19.1 77.6 24.45 77.6 30.65C77.6 34.05 77.15 37.45 76.25 40.85C75.35 44.15 73.65 47.65 71.15 51.35C68.65 55.05 65 59.2 60.2 63.8L24.35 97.85L20.3 90.5H81.65V107H4.25Z", fill: "#CDCDCD", fillOpacity: "0.26" }) })));
};
